import { FC, useMemo } from 'react'
import { CondicaoCatalogo } from '../../formularios/core/condicao/catalogo'
import {
  descreverCondicao,
  dicionarioDeCampos,
} from '../../formularios/core/condicao/descreverCondicao'
import { FormularioVinculado } from '../core/_models'

type Props = {
  formulario?: FormularioVinculado
  catalogo?: CondicaoCatalogo
  bloqueado?: boolean
  motivoBloqueio?: string
}

/** Formulário vinculado, só leitura (T7a AC2). Edição é do construtor (T8b), não daqui. */
export const FormularioVinculadoLeitura: FC<Props> = ({
  formulario,
  catalogo,
  bloqueado,
  motivoBloqueio,
}) => {
  const campos = useMemo(() => formulario?.campos ?? [], [formulario?.campos])
  const dicionario = useMemo(() => dicionarioDeCampos(campos, catalogo), [campos, catalogo])

  if (!formulario) {
    return <p className='text-muted'>Nenhum formulário vinculado.</p>
  }

  return (
    <div>
      <div className='d-flex flex-wrap align-items-center gap-3 mb-4'>
        <h4 className='fw-bold mb-0'>{formulario.nome}</h4>
        {bloqueado && (
          <span className='badge badge-light-warning'>
            Bloqueado para edição{motivoBloqueio ? `: ${motivoBloqueio}` : ''}
          </span>
        )}
      </div>
      {campos.length === 0 ? (
        <p className='text-muted'>Este formulário não tem campos.</p>
      ) : (
        <div className='table-responsive'>
          <table className='table table-row-bordered align-middle'>
            <caption className='visually-hidden'>Campos do formulário {formulario.nome}</caption>
            <thead>
              <tr className='fw-bold text-muted'>
                <th scope='col'>Código</th>
                <th scope='col'>Rótulo</th>
                <th scope='col'>Tipo</th>
                <th scope='col'>Obrigatório</th>
                <th scope='col'>Opções</th>
                <th scope='col'>Condição de exibição</th>
              </tr>
            </thead>
            <tbody>
              {campos.map((campo) => (
                <tr key={campo.codigo}>
                  <td>
                    <code>{campo.codigo}</code>
                  </td>
                  <td>{campo.rotulo}</td>
                  <td>
                    {campo.tipo}
                    {campo.multiplo ? ' (múltiplo)' : ''}
                  </td>
                  <td>{campo.obrigatorio ? 'Sim' : 'Não'}</td>
                  <td>
                    {(campo.opcoes ?? []).length === 0
                      ? '—'
                      : (campo.opcoes ?? []).map((opcao) => opcao.descricao).join(', ')}
                  </td>
                  <td>
                    {campo.condicaoExibicao
                      ? descreverCondicao(campo.condicaoExibicao, dicionario).texto
                      : 'Sempre visível'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
